module.exports = __webpack_public_path__ + "img/722-132e48.png";